import { render } from "./ticket_detail_modal.vue?vue&type=template&id=c81aad0a"
import script from "./ticket_detail_modal.vue?vue&type=script&lang=js"
export * from "./ticket_detail_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__